<template>
    <a-card class="create-edit-wrap">
        <h2>
            Create/Edit Sessions
            <div class="border"></div>
        </h2>
        <div class="form">
            <p>Allows you to create new agenda sessions/modify existing ones.</p>
            <div
                v-if="!isOpen" 
                class="closed"
            >
                <a-button 
                    type="primary" 
                    icon="plus"
                    class="button"
                    @click="emitIsOpen(true)"
                >
                    Add Section
                </a-button>
            </div>
            <div
                v-if="isOpen" 
                class="opened"
            >
                <agenda-edit-form
                    v-bind="$props"
                    :agenda="agendaCurrent"
                    @cancel-edit="handleCancel"
                    @get-agendas="$emit('get-agendas')"
                    @get-companies="$emit('get-companies', $event)"
                    @get-users="$emit('get-users', $event)"
                ></agenda-edit-form>
            </div>
        </div>
    </a-card>
</template>

<script>
import AgendaEditForm from './AgendaEditForm.vue';
export default {
    components: {
        AgendaEditForm,
    },
    props: {
        agendas: {
            type: Array,
        },
        locations: {
            type: Array,
        },
        types: {
            type: Array,
        },
        users: {
            type: Array,
        },
        companies: {
            type: Array,
        },
        tags: {
            type: Array,
        },
        selectedTimezoneOffset: {
            type: Number
        },
        agendaCurrent: {
            type: Object,
        },
        isOpen: {
            type: Boolean,
        },
    },
    methods: {
        emitIsOpen (bool) {
            this.$emit('set-is-open', bool);
        },
        handleCancel () {
            this.$emit('cancel-edit');
            this.emitIsOpen(false);
        },
    },
};
</script>

<style lang="scss" scoped>
.create-edit-wrap {
    // this is set for AgendaEditForm buttons line (its absolute)
    position: relative;
    * {
        font-family: 'Roboto';
    }
    margin: 2em 0;
    .button {
        display: flex;
        align-items: center;
        padding: 8px 16px;

        width: 141px;
        height: 40px;

        background: #2295D6;
        border-radius: 2px;
    }
    p {
        color: #001529;
        max-width: 876px;
    }
    h2 {
        position: relative;
        height: 50px;
        font-weight: 700;
        .border {
            $padding: 24px;
            background: #e8e8e8;
            height: 1px;
            width: calc(100% + #{$padding} * 2);
            left: calc(0px - #{$padding});
            position: absolute;
            bottom: 0;
        }
    }
}
</style>